import { Feather } from '@expo/vector-icons';
import { colors, spacing } from '_/space-management/constants/theme';
import React from 'react';
import { View, StyleSheet, TouchableOpacity, TextStyle, StyleProp } from 'react-native';

import Text from '../Text/index';
import { fontSizes } from '_/config/theme';
import { renderTextWithLinks } from '_/space-management/utils';

interface TitleProps {
  title?: string | null;
  hasCloseButton?: boolean;
  onPress?: () => void;
  style?: StyleProp<TextStyle>;
  numberOfLines?: number;
}

export default function Title({
  title,
  hasCloseButton,
  onPress,
  style,
  numberOfLines = 1,
}: TitleProps) {
  return (
    <View style={styles.componentHeader}>
      <Text
        fontSize={fontSizes.lg}
        color={colors.black}
        fontType="bold"
        style={[styles.title, style]}
        numberOfLines={numberOfLines}
      >
        {renderTextWithLinks(title)}
      </Text>
      {hasCloseButton && (
        <TouchableOpacity hitSlop={{ top: 12, right: 12, bottom: 12, left: 12 }} onPress={onPress}>
          <Feather name="x" size={24} />
        </TouchableOpacity>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  componentHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: spacing.md,
    marginTop: spacing.md,
    marginBottom: spacing.xxs,
  },
  title: {
    maxWidth: '100%',
  },
});
